import { Input } from '@/components/ui/input'

// `id` lets a caller namespace the control (e.g. when the form renders twice on a page).
const TextField = ({ field, id = field.id, value, onChange, disabled }) => (
  <Input
    type="text"
    id={id}
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    placeholder={field.label}
    disabled={disabled}
  />
)

export default TextField
